import { createSlice } from "@reduxjs/toolkit";
import constants from "../../../assets/js/constants";

const slice = createSlice({
  name: `${constants.STATE_MANAGEMENT.AUXILIARY}/ui/sections`,
  initialState: {
    currentSection: 0,
    displayContent: false,
    list: [],
  },
  reducers: {
    sectionChanged: (sections, action) => {
      sections.currentSection = action.payload;
    },
    sectionsAdded: (sections, action) => {
      sections.list = action.payload;
    },
    sectionContentDisplayed: (sections, action) => {
      sections.displayContent = action.payload;
    },
  },
});

export const changeSection = (sectionNumber) => (dispatch) => {
  dispatch(sectionChanged(sectionNumber));
};

export const addAllSections = (sections) => (dispatch, getState) => {
  if (getState().ui.sections.list.length === 0)
    dispatch(sectionsAdded(sections));
};

export const toggleSectionContentDisplay = (display) => (dispatch) => {
  dispatch(sectionContentDisplayed(display));
};

export const { sectionChanged, sectionsAdded, sectionContentDisplayed } =
  slice.actions;
export default slice.reducer;
